import "../../../../../css/AML/PopUp/SubmissionPopUp.css";
import { ReactComponent as ConfirmIcon } from "../../../../../assets/icons/aml/check.svg";
import SecondaryButton from "../Buttons/SecondaryButton";

const SubmissionPopUp = ({ onClose }) => {
  return (
    <div className="submission-popup-overlay">
      <div className="submission-popup-container">
        <ConfirmIcon />
        <div className="AML-Text-Title">Check Submitted Successfully</div>
        <div className="AML-Text-Body">
          Your identity verification check has been processed and submitted for
          review.
        </div>
        <SecondaryButton
          label="OK"
          onClick={() => {
            // Close the pop-up
            onClose();
          }}
        />
      </div>
    </div>
  );
};

export default SubmissionPopUp;
